import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLeaveOrganization } from '../../../entities/member';
import { identityErrorMessage } from '../../../shared/api/identity-error';
import { Button } from '../../../shared/ui/button';
import { ConfirmDialog } from '../../../shared/ui/confirm-dialog';
import { toast } from '../../../shared/ui/sonner';

/** Any member may leave; the last owner is refused with `last_owner` (Q32), shown in the dialog. */
export function LeaveOrgButton({
  org,
  onLeft,
}: {
  org: { id: string; name: string };
  onLeft: () => void;
}) {
  const { t } = useTranslation('org');
  const leave = useLeaveOrganization(org.id);
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button variant="outline" onClick={() => setOpen(true)}>
        {t('settings.leave.action')}
      </Button>
      <ConfirmDialog
        open={open}
        onOpenChange={setOpen}
        title={t('settings.leave.confirmTitle', { org: org.name })}
        description={t('settings.leave.confirmBody')}
        confirmLabel={t('settings.leave.confirm')}
        cancelLabel={t('settings.leave.cancel')}
        errorMessage={identityErrorMessage}
        onConfirm={async () => {
          await leave.mutateAsync(undefined);
          toast.success(t('settings.leave.done', { org: org.name }));
          onLeft();
        }}
      />
    </>
  );
}
